module.exports = __webpack_public_path__ + "static/media/item_04.7c77771e.jpg";